import { render, staticRenderFns } from "./AnxFooter.vue?vue&type=template&id=b4f60f64&scoped=true&"
import script from "./AnxFooter.vue?vue&type=script&lang=ts&"
export * from "./AnxFooter.vue?vue&type=script&lang=ts&"
import style0 from "./AnxFooter.vue?vue&type=style&index=0&id=b4f60f64&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4f60f64",
  null
  
)

export default component.exports